import pixResearchDashboardGuard from '@/guards/pixResearchDashboard.guard.js';
import dashboardNavbarConst from '@/consts/dashboardNavbar.const.js';
import genericTabsPathConst from '@/consts/genericTabsPath.const';
import pixResearchGuard from '@/guards/pixResearch.guard.js';
import genericTabConst from '@/consts/genericTab.const.js';

const researchRoutes = [
  {
    path: '/researchDashboard',
    name: 'researchDashboard',
    component: () => import(/*webpackChunkName: "researchDashboard" */ '@/pages/researchDashboard/pixResearchDashboard.vue'),
    beforeEnter: pixResearchDashboardGuard,
    meta: { id: dashboardNavbarConst.COMPS },
  },
  {
    name: 'research',
    path: '/research/:searchId',
    component: () => import(/* webpackChunkName: "pixResearch" */ '@/pages/research/pixResearch.vue'),
    props: true,
    meta: { auth: true },
    beforeEnter: pixResearchGuard,

    children: [
      {
        path: `/research/:searchId/${genericTabsPathConst[genericTabConst.LEASE_RESEARCH]}`,
        name: 'researchLeaseComparables',
        component: () => import(/* webpackChunkName: "pixResearchComparable" */ '@/pages/research/pixResearchComparable.vue'),
      },
      {
        path: `/research/:searchId/${genericTabsPathConst[genericTabConst.SALES_RESEARCH]}`,
        name: 'researchSalesComparables',
        component: () => import(/* webpackChunkName: "pixResearchComparable" */ '@/pages/research/pixResearchComparable.vue'),
      },
      {
        path: `/research/:searchId/${genericTabsPathConst[genericTabConst.LAND_RESEARCH]}`,
        name: 'researchLandComparables',
        component: () => import(/* webpackChunkName: "pixResearchComparable" */ '@/pages/research/pixResearchComparable.vue'),
      },
    ],
  },
];

export default researchRoutes;
